import { reportButtonLog } from '@intelligence/v3/utils/logReporter';
import {
  dbiBtnLogMes
} from '@intelligence/utils/buriedPointCfg';

/**
 * Simple utility function for logging DataBrain card clicks
 * @param cardItem - The card item that was clicked
 * @param gameId - Game ID for logging context
 * @param gameName - Game name for logging context
 */
export function logDataBrainCardClick(
  cardItem: any,
  gameId: string,
  gameName: string,
): void {
  const config = dbiBtnLogMes.dataBrainCardClick;

  const buriedPointConfig = {
    pageId: config.pageId,
    buttonId: config.buttonId,
    typeId: config.typeId,
    extInfo: JSON.stringify({
      gameId,
      gameName,
      componentName: config.componentName,
      componentValue: {
        clickedMetric: cardItem?.titleContent || 'Unknown',
      },
    }),
  };

  console.log(
    'DataBrainCardClickLogger: Sending buried point log:',
    buriedPointConfig,
  );

  // Send the log
  reportButtonLog(buriedPointConfig);
}
